import React from 'react';
import MemberForm from '../components/MemberForm'
import GroupForm from '../components/GroupForm'

import ActivateMemberForm from '../components/ActivateMemberForm'

import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Descriptions,Modal,Spin, Card,Tabs,Form } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,DownloadOutlined,EditOutlined,WalletFilled,LoadingOutlined,UnorderedListOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import {
  Col,
  Row,
} from 'reactstrap';
import ReactExport from "@ibrahimrahmani/react-export-excel";
import LoanIssuanceListPerMember from './LoanIssuancesListViewPerMember'
import FinancialStatementReportPerMember from './FinancialStatementReportViewPerMember'

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}

const { TabPane } = Tabs;
const FormItem=Form.Item;


const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

var sacco= ''
var bizuserid= ''
var bizuserid= ''
var token= ''

class MemberList extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    members: [],
    viewpaymentmodal:false,
    expensedetails:{},
    userprofile:{},
    datarequested:true,
    memberactivationformvisible:false,
    selectedmemberid:'',
    userrights:{},
    current_selected_member:'',
    loan_particular_data_loading:false,

  };

  componentDidMount(){

    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
    }else{
       sacco= ''
       bizuserid= ''
    }
    
    if(localStorage.getItem("bizuserid")){
       bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
     }else{
        bizuserid= ''
     }
    
     if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

   this.componentmountactions();

}

//component mount method
componentmountactions=()=>{
  axios.get(serverconfig.backendserverurl+`/api/members_dataview/?sacco=${sacco}`)
  .then(res => {
      this.setState({
        members:res.data
      })

  })

  axios.get(serverconfig.backendserverurl+`/api/accountrights/?user=${bizuserid}`)
  .then(res => {
      this.setState({
        userrights:res.data[0]
      })
      this.setState({datarequested:false})
  })


}

    //////////////////////////////////////////////////
  //handle delete here
  handleDelete = id => {
    let form_data1 = new FormData();
    form_data1.append('memberid', id);
    form_data1.append('sacco', sacco);

    axios.post(`${serverconfig.backendserverurl}/customqueries/deletemember`, form_data1, {
      headers: {
        'content-type': 'multipart/form-data'
      }
      }).then(res =>{
      message.info("successfully deleted") 
      this.componentmountactions();
     }
     );

  };

    //open mdi guarantor form
    openmemberactivationform=(val)=>{
      this.setState({selectedmemberid:val})
      this.setState({memberactivationformvisible:true})
    }
  
    closememberactivationform=()=>{
      this.setState({memberactivationformvisible:false})
    }


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};

  render() {

      var columns = [
        {
          title: 'Account Number',
          dataIndex: 'AccountNumber',
          key: 'id',
          ...this.getColumnSearchProps('AccountNumber'),
        },
        {
          title: 'Account Name',
          dataIndex: 'FullName',
          key: 'id',
          ...this.getColumnSearchProps('FullName'),
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          key: 'id',
          ...this.getColumnSearchProps('gender'),
        },
        {
          title: 'Member Type',
          dataIndex: 'membertypename',
          key: 'id',
          ...this.getColumnSearchProps('membertypename'),
        },
        {
          title: 'Account Contact',
          dataIndex: 'RegisteredPhoneNumber1',
          key: 'id',
          ...this.getColumnSearchProps('RegisteredPhoneNumber1'),
        },
        {
          title: 'Account Status',
          dataIndex: 'account_status',
          key: 'id',
          ...this.getColumnSearchProps('account_status'),
        },

        {
          title: 'Date of joining',
          dataIndex: 'DateOfJoining',
          key: 'id',
          ...this.getColumnSearchProps('DateOfJoining'),
        },
        {
          title: 'Savings balance',
          dataIndex: 'savings_balance',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Shares amount',
          dataIndex: 'sharesamount_balance',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Loan balance',
          dataIndex: 'loan_balance',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Fixed deposit balance',
          dataIndex: 'fixed_deposit_balance',
          key: 'id',
          render:text=><CurrencyFormat value={text} displayType={'text'} thousandSeparator={true}  />
        },
        {
          title: 'Action',
          dataIndex: 'id',
          key: 'id',
          render: text =>
          <p>
          <Popover content={<p>Click here to edit,view details</p>} title="Edit,View">
           <Link to={`/members/${text}`}><FundViewOutlined style={{color:'blue'}}/></Link>
          </Popover>
          &nbsp;&nbsp;&nbsp;

          {
            this.state.userrights.accountactivation?
            <Popover content={<p>Click here to change account status</p>} title="Change status">
            <EditOutlined style={{color:'green'}} onClick={()=>{this.openmemberactivationform(text)}}/>
            </Popover>
            :
            null
          }

          &nbsp;&nbsp;&nbsp;
          <Popover content={<p>Click here to go to quick menu</p>} title="Quick menu">
            <Link to={`/quickmenu/`}>
            <UnorderedListOutlined style={{color:'blue'}}/>
            </Link>
          </Popover>
          &nbsp;&nbsp;&nbsp;

          <Popover content={<p>Click here to delete member</p>} title="Delete">
          <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(text)}>
            <DeleteOutlined style={{color:'red'}}/>
          </Popconfirm>
          </Popover>
          
          </p>,
        }
  
      ];
    
    
    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>           </div>
      )

    }else{
      return(
        <div>
            <Collapse defaultActiveKey={['1']} onChange={this.callback}>
            <Panel header={<h4 style={{fontWeight:'bolder'}}>AVAILABLE MEMBER ACCOUNTS</h4>} key="1">
              <div style={{display:'flex',flexDirection:'row'}}>
              <ExcelFile filename={"Pisacco - All Members list"}  element={<Button type='primary' icon={<DownloadOutlined/>}>Download Excel</Button>}>
                <ExcelSheet data={this.state.members} name="All members list">
                    <ExcelColumn label="Acc No" value="AccountNumber"/>
                    <ExcelColumn label="Acc Name" value="FullName"/>
                    <ExcelColumn label="Member type" value="membertypename"/>
                    <ExcelColumn label="Member Contact" value="RegisteredPhoneNumber1"/>

                    <ExcelColumn label="Savings" value="savings_balance"/>
                    <ExcelColumn label="Shares number" value="sharesnumber_balance"/>
                    <ExcelColumn label="Shares amount" value="sharesamount_balance"/>
                    <ExcelColumn label="Loan balance" value="loan_balance"/>
                    <ExcelColumn label="Loan interest" value="loaninterest_balance"/>

                    <ExcelColumn label="Savings reserve" value="savingsloan_security_balance"/>
                    <ExcelColumn label="Fixed deposit balance" value="fixed_deposit_balance"/>
                    <ExcelColumn label="Loan fine" value="loanfine_balance"/>

                </ExcelSheet>
            </ExcelFile>

              </div>
              <br></br>

            
            <Table   
            columns={columns} 
            size='small'
            scroll={{ x: 1000 }}
            dataSource={this.state.members} 
            pagination={{showQuickJumper:true,showSizeChanger:true }}
            bordered
            
            expandable={{
              expandedRowRender: (record) =>{
                if (Number(record.id)===Number(this.state.current_selected_member)){
                  return (
                    <div
                      style={{
                        margin: 0,
                      }}
                     >

                      {
                        this.state.loan_particular_data_loading===true?
                        <div style={{display:'flex',margin:20}}>
                        <Spin indicator={antIcon} />
                        </div>
                        :

                     <Tabs defaultActiveKey="1" onChange={callback}>
                         <TabPane tab="Financial statement" key="02" >
                          <FinancialStatementReportPerMember member_id={record.id} />


                        </TabPane>
                        <TabPane tab="Member loans" key="01" >
                          <LoanIssuanceListPerMember member_id={record.id} />

                        </TabPane>
                      </Tabs>

                      }

                    </div>
                    );
                }else{
                  return null;
                }
              } ,
              rowExpandable: (record) => record.id !== this.state.current_selected_member.id,
              onExpand:(condition,record)=>{
                this.setState({loan_particular_data_loading:false})

                //set curent id
                this.setState({current_selected_member:record.id})

              },
            }}
            
            
            
            />
            <br />


            </Panel>
            </Collapse>
            <br></br>

            <Card>
            <h5 style={{justifyContent:'start',display:'flex',color:'green'}}>Member creation form</h5>
            <MemberForm 
            requestType="post"
            expenseID={null}
            btnText="Create"
            /> 
            </Card>


            <Modal              
              visible={this.state.memberactivationformvisible}
              title={"Account status Form"}
              onCancel={this.closememberactivationform}
              style={{width:1000}}
              footer={[
                <Button key="back" onClick={this.closememberactivationform}>
                  Cancel
                </Button>
                ]}
                >
                <ActivateMemberForm memberid={this.state.selectedmemberid} />

            </Modal> 
        </div>
    )

    }

  }
}

export default MemberList; 
